import { useState } from 'react'
import { MdOutlineCopyAll, MdOutlineModeEdit } from 'react-icons/md'
import { RiDeleteBin6Line } from 'react-icons/ri'
import Modal from '../../layouts/Modal'
import { useNavigate } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import { sourceConverter } from '../Sources'
import { DELETE_CAMPAIGN_QUERY } from '../../services/GraphQLQueries'
import { useMutation } from '@apollo/client'

const TrackerTableCampaign = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const navigate = useNavigate()

  const [deleteCampaign] = useMutation(DELETE_CAMPAIGN_QUERY)

  const deleteCampaignFunc = async () => {
    // 1️⃣ close modal immediately
    setIsModalOpen(false)

    // 2️⃣ remove the row immediately from parent
    if (props.removeData) props.removeData(props.originalRow.id)

    // 3️⃣ perform async deletion in backend
    try {
      await deleteCampaign({
        variables: {
          campaignId: props.originalRow.id,
        },
      })
    } catch (error) {
      console.error('Error deleting campaign:', error)
    }
  }

  const navToEdit = (data) => {
    navigate('/edit-tracker', { state: { data } })
  }

  const copyCode = async (id, text) => {
    navigator.clipboard.writeText(text)
    let span = document.getElementById('copyMessage' + id)
    span.style.zIndex = 999
    span.style.animation = 'fade 2s forwards'
    setTimeout(() => {
      span.style.animation = ''
      span.style.zIndex = -1
    }, 2000)
  }

  return (
    <>
      <div className="flex justify-between items-center tracker">
        <div className="block h-12 w-full font-unbounded">
          <div className="flex justify-between items-center text-[#B69C60] text-sm">
            <div className="uppercase w-3/4 flex">
              <div>{sourceConverter(props.originalRow.platform)}</div>
              <div>&nbsp;&gt;&nbsp;{props.originalRow.campaignType}</div>
            </div>
            <div
              className="inline-flex items-center cursor-pointer"
              onClick={() =>
                copyCode(
                  props.originalRow.id,
                  `${props.originalRow.landingPageURL}${
                    props.originalRow.landingPageURL?.includes('?') ? '&' : '?'
                  }cid=${props.originalRow.id}`
                )
              }
            >
              <MdOutlineCopyAll className="min-w-[16px]" />
              <div>M - KEY</div>
              <span
                id={'copyMessage' + props.originalRow.id}
                className="tooltiptext bottom-[75%] w-[10vw]"
              >
                Copied to clipboard
              </span>
            </div>
          </div>
          <div className="flex justify-between items-center ">
            <NavLink
              className="inline-block w-[70%]"
              to={'/campaign-overview/' + props.originalRow.id}
            >
              {props.cellValue}
            </NavLink>

            <div
              className="trackerEdit flex items-center text-sm mr-2 cursor-pointer"
              onClick={() => navToEdit(props.originalRow)}
            >
              <div className="w-full inline-flex items-center mr-1 text-[#FAD070]">
                <MdOutlineModeEdit /> EDIT
              </div>
            </div>

            <div
              className="trackerEdit flex items-center text-sm cursor-pointer"
              onClick={() => setIsModalOpen(true)}
            >
              <div className="w-full inline-flex items-center text-[#FAD070]">
                <RiDeleteBin6Line /> DELETE
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <Modal setIsModalOpen={setIsModalOpen} backGroundClass={'darkBG'}>
          <div className="modalContent mx-auto p-12">
            <p className="w-full text-l text-[#000000] text-center mx-auto">
              Are you sure you want to delete? This action cannot be undone,
              and all data will be lost.
            </p>
          </div>
          <div className="modalActions">
            <div className="actionsContainer">
              <button
                className="cancelBtn bg-metrinome-orange"
                onClick={() => setIsModalOpen(false)}
              >
                Close
              </button>
              <button
                className="cancelBtn bg-metrinome-orange"
                onClick={deleteCampaignFunc}
              >
                Yes
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}

export default TrackerTableCampaign
